import * as React from 'react'
import {FC, memo, useState} from 'react'
import {Row, Col} from 'antd/lib/grid'
import 'antd/lib/grid/style'
import Form, {FormInstance} from 'antd/lib/form'
import 'antd/lib/form/style'
import Input from 'antd/lib/input'
import 'antd/lib/input/style'
import CalcCard from '../../../../common/components/calc-card'
import IDS from '../../constants/ids'
import {COMPONENT_SIZE} from '../../constants'
import LABELS from '../../constants/labels'
import GlobalOptionsInterface from '../../types/global-options'
import 'antd/lib/spin/style'
import Checkbox from 'antd/lib/checkbox'
import 'antd/lib/checkbox/style'
import requiredTrueCheckboxValidator from '../../../../../common/helpers/validators/required-true-checkbox'
import {
    URL_AGREEMENT_OF_PERSONAL_DATA,
    URL_POLICY_PERSONAL_DATA,
} from '../../../../common/constants/doc-urls'
import {URL_RULES, URL_RULES_COMPLEX} from '../../constants'
import Individual from "./insurer/Individual";
import { Radio } from 'antd'
import {RadioChangeEvent} from "antd/lib/radio/interface";
import IndividualEntrepreneur from "./insurer/IndividualEntrepreneur";
import LegalEntity from "./insurer/LegalEntity";

const {Item} = Form

interface ContactsPropsInterface {
    form: FormInstance
    globalOptions: GlobalOptionsInterface
}

const Contacts: FC<ContactsPropsInterface> = memo(({form, globalOptions}) => {
    const [insurerType, setInsurerType] = useState<string>('individual')
    const isForAgents =
        globalOptions.calcMode &&
        globalOptions.calcMode.match(/^(agent|underwriter|precheck|superuser)$/)

    const handleInsurerTypeChange = (event: RadioChangeEvent) => setInsurerType(event.target.value)

    return (
        <CalcCard>
            <h2>Контактные данные {isForAgents && 'Страхователя'}</h2>
            <Item name={['insurer', 'type']}>
                <Radio.Group onChange={handleInsurerTypeChange}>
                    <Radio.Button value="individual">Физ. лицо</Radio.Button>
                    <Radio.Button value="juridical">Юр. лицо</Radio.Button>
                    <Radio.Button value="ip">ИП</Radio.Button>
                </Radio.Group>
            </Item>

            {insurerType === 'individual' && (
                <Individual path={['insurer']} isForAgents={false} globalOptions={globalOptions}/>
            )}

            {insurerType === 'ip' && (
                <IndividualEntrepreneur path={['insurer']}/>
            )}

            {insurerType === 'juridical' && (
                <LegalEntity path={['insurer']}/>
            )}

            <Item name={IDS.CALCULATION_ID} label={LABELS.CALCULATION_ID} hidden={true}>
                <Input size={COMPONENT_SIZE} disabled/>
            </Item>

            <Row gutter={24}>
                <Col span={24}>
                    <p>
                        После отправки заявки Вам будет выслана анкета-заявление на страхование
                        груза. Внесите в неё необходимые данные для расчёта и составления страхового
                        договора.
                    </p>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={24}>
                    <Item
                        name={IDS.AGREEMENT_WITH_PROTECTION_POLICY}
                        valuePropName={'checked'}
                        rules={[
                            {
                                message: 'Поставьте отметку о согласии',
                                validator: requiredTrueCheckboxValidator,
                            },
                        ]}
                        required
                    >
                        <Checkbox>
                            <span>
                                Я согласен на обработку{' '}
                                <a
                                    className={'e-link_underline'}
                                    href={URL_AGREEMENT_OF_PERSONAL_DATA}
                                    target={'_blank'}
                                >
                                    Персональных данных (ПД)
                                </a>{' '}
                                и ознакомился с{' '}
                                <a
                                    className={'e-link_underline'}
                                    href={URL_POLICY_PERSONAL_DATA}
                                    target={'_blank'}
                                >
                                    Политикой защиты и обработки ПД
                                </a>
                                .
                            </span>
                        </Checkbox>
                    </Item>
                </Col>
                <Col span={24}>
                    <Item
                        name={IDS.AGREEMENT_WITH_RULES}
                        rules={[
                            {
                                message: 'Поставьте отметку о согласии с правилами страхования',
                                validator: requiredTrueCheckboxValidator,
                            },
                        ]}
                        valuePropName={'checked'}
                    >
                        <Checkbox className={'e-awr'}>
                            С{' '}
                            <a className={'e-link_underline'} href={URL_RULES} target={'_blank'}>
                                правилами страхования грузов
                            </a>{' '}
                            и{' '}
                            <a
                                className={'e-link_underline'}
                                href={URL_RULES_COMPLEX}
                                target={'_blank'}
                            >
                                правилами комплексного страхования грузов
                            </a>{' '}
                            ознакомлен и согласен.
                        </Checkbox>
                    </Item>
                </Col>
            </Row>
        </CalcCard>
    )
})

export default Contacts
